import { twMerge } from "tailwind-merge";

export const Picture = (props) => {
  const sizeList = props.sizeList;
  const imageUrl = props.imageUrl;
  const altText = props.altText;
  const loading = props.loading;
  const multiplier = props.multiplier ?? 1.6;

  return (
    <picture
      onClick={props.onClick ? props.onClick : null}
    >
      <For each={sizeList.reverse()}>{(size, index) => {
        return (
          <Show
            fallback={(
              <source
                media={`(min-width: ${size.pageWidth})`}
                srcset={`
                ${imageUrl}&width=${size.imgWidth} 1x,
                ${imageUrl}&width=${size.imgWidth * multiplier} 2x
              `}
              />
            )}
            when={index() == sizeList.length - 1}
          >
            <img
              loading={loading ?? "lazy"}
              class={twMerge(
                "",
                props.class ?? ""
              )}
              alt={altText} // image.alt is not there
              src={`${imageUrl}&width=${size.imgWidth}`}
              srcset={`
              ${imageUrl}&width=${size.imgWidth} 1x,
              ${imageUrl}&width=${size.imgWidth * multiplier} 2x
            `}
              width="auto"
              height="auto"
              style={`background-image: url('${ imageUrl }&width=8');
            background-size: cover;
            backround-position:center;
            color: transparent;
            ${ props.style ?? "" }
            `}
            />
          </Show>
        )
      }}</For>
    </picture>
  )
}
